import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const TimesIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('TimesIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 3 8 8m0 0-5 5m5-5 5 5M8 8 3 3"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
TimesIcon.id = 'TimesIcon';
TimesIcon.displayName = 'TimesIcon';
export default TimesIcon;
